export class ForbiddenError extends Error {
  name = "ForbiddenError";
}
